module.exports = __webpack_public_path__ + "static/media/ItemsIsItemsUnityInspector.b65e33aa.png";